var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"base-button",attrs:{"icon":"ion close-outline","unelevated":"","color":"tes-red-light","label":"رد تراکنش","size":"lg"},on:{"click":_vm.rejectDialogShow}})}
var staticRenderFns = []

export { render, staticRenderFns }